export default __webpack_public_path__ + "images/X1.27b6cba.png";